export default __webpack_public_path__ + "static/media/cr_img1.19549e71.jpg";